module.exports = __webpack_public_path__ + "static/media/7c42e9e1-8d99-4ff8-af0a-936f5fdab747.cb5c7506.jpg";